import React, { useContext, useState } from 'react'
import { COLOR } from './ColorContext'

export const LIBRARIES = [
	{
		title: 'Spin & Go',
		key: COLOR.GREEN,
	},
	{
		title: 'HU Ante',
		key: COLOR.BLUE,
	},
	{
		title: '6-Max Cash',
		key: COLOR.YELLOW,
	},
	{
		title: 'MTT',
		key: COLOR.RED,
	},
	{
		title: 'HU Cash',
		key: COLOR.PURPLE,
	},
]

const LibraryContext = React.createContext()

export const useLibrary = () => {
	return useContext(LibraryContext)
}

export const LibraryProvider = ({ children }) => {
	const [library, setLibrary] = useState(LIBRARIES[0].title)

	const handleLibrary = (library) => setLibrary(library)

	return (
		<LibraryContext.Provider
			value={{
				library,
				handleLibrary,
			}}
		>
			{children}
		</LibraryContext.Provider>
	)
}
